import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Drawer} from 'antd';
import {useAsync} from 'react-use';
import _ from 'lodash';

import {getNewsById} from './extra-news';
import ExtraNewsView from './ExtraNewsView';

const ExtraNewsDrawer = forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);
    const [newsId, setNewsId] = useState(null);
    const {value} = useAsync(() => {
        if (!newsId) {
            return Promise.resolve({});
        }
        return getNewsById(newsId).then(({data}) => data);
    }, [newsId]);

    // console.log('news...', value, loading);

    function show(id) {
        setVisible(true);
        setNewsId(id);
    }

    function hide() {
        setVisible(false);
        setNewsId(null);
    }

    useImperativeHandle(ref, () => ({
        show,
        hide,
    }));

    return (
        <Drawer
            visible={visible}
            width={800}
            onClose={hide}
            destroyOnClose={false}
            title={'上传图文详细'}
        >
            {!_.isEmpty(value) && <ExtraNewsView news={value} />}
        </Drawer>
    );
});

ExtraNewsDrawer.displayName = 'ExtraNewsDrawer';
ExtraNewsDrawer.propTypes = {};

export default ExtraNewsDrawer;
